// Action constants
export const ADD_IMAGE = 'ADD_IMAGE';
export const REMOVE_IMAGE = 'REMOVE_IMAGE';


// WEBPACK FOOTER //
// ./constants/index.js